import { useEffect, useRef } from 'react'
import { useTrackEvent } from './track-event'
import type { ETrackingEvent } from './type'

type UseScrollTrackingProps<T = Record<string, unknown>> = {
  elementRef: React.RefObject<HTMLElement | null>
  event: ETrackingEvent
  active?: boolean
} & T

export const useScrollTracking = <T = Record<string, unknown>>({
  event,
  elementRef,
  active = true,
  ...data
}: UseScrollTrackingProps<T>) => {
  const tracking = useTrackEvent()
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    const node = elementRef.current

    if (!active || hasTrackedRef.current || !node) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Gửi tracking khi section xuất hiện trong viewport
            tracking({
              ...data,
              event,
            })

            observer.disconnect() // chỉ track 1 lần
          }
        })
      },
      {
        threshold: 0.25, // ít nhất 25% section visible
      }
    )

    observer.observe(node)

    return () => {
      observer.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, elementRef, event, hasTrackedRef])
}
